import $ from "jquery";
$(document).ready(function () {
    if ($("#blog_page").length) {
        const form = document.getElementById("searchForm");
        const form1 = document.getElementById("searchForm1");
        let pageNumber = 1;

        $("#searchForm").submit(function (e) {
            e.preventDefault();
        });

        $("#lnkSearch").click(function () {
            getSearch();
        });

        $("#lnkSearch1").click(function () {
            getSearch1();
        });

        $("#searchText").on("keydown", function(e) {
            if (e.key === "Enter") {
                e.preventDefault();
                getSearch();
            }
        });

        $("#searchText1").on("keydown", function(e) {
            if (e.key === "Enter") {
                e.preventDefault();
                getSearch1();
            }
        });

        const $blogsContainer = $(".blogs");
        const $showMoreButton = $(".show-more");

        $blogsContainer.height("auto");

        if ($blogsContainer.length && $blogsContainer.prop("scrollHeight") > 2000) {
            $showMoreButton.css("display", "block");
        } else {
            $showMoreButton.css("display", "none");
        }

        function performSearch(formId) {
            const $form = $("#" + formId);
            const $searchInput = $("#" + formId.replace("Form", "Text"));
            const searchText = $searchInput.val();

            if (searchText.trim() === "") {
                return; // Don't search if input is empty
            }

            const link = $form.attr("action") + "&searchText=" + encodeURI(searchText);
            window.location.href = link;
        }

        function getSearch() {
            performSearch("searchForm");
        }

        function getSearch1() {
            performSearch("searchForm1");
        }

        $("#btnShowMore").click(function () {
            const $showMoreBtn = $(this);
            const $showMoreContainer = $(".show-more");

            $showMoreBtn.prop("disabled", true).addClass("loading");
            pageNumber++;

            const baseUrl = $showMoreBtn.attr("action");
            const requestUrl = baseUrl + "&pageNumber=" + pageNumber;

            $("#spinner-container").show();

            let pageSize = 25;
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has("pageSize")) {
                pageSize = parseInt(urlParams.get("pageSize"), 10);
            }

            $.ajax({
                url: requestUrl,
                timeout: 30000, // 30 second timeout
                success: function (data) {
                    $("#spinner-container").hide();

                    $showMoreBtn.prop("disabled", false).removeClass("loading");

                    if (data.trim() === "") {
                        $showMoreContainer.css("display", "none");
                    } else {
                        $("#blogs").append(data);

                        const tempContainer = $("<div></div>").html(data);
                        const articleCount = tempContainer.find(".blog-box").length;

                        if (articleCount < pageSize) {
                            $showMoreContainer.css("display", "none");
                        }
                    }
                },
                error: function(xhr, status, error) {
                    $("#spinner-container").hide();
                    $showMoreBtn.prop("disabled", false).removeClass("loading");
                    console.error("Error loading more articles:", status, error);
                }
            });
        });
    }
});
